import React, { Component } from "react";
import {  Row, Col, Button, ListGroup, Form, Alert , Modal } from "react-bootstrap";

//import { LinkContainer } from "react-router-bootstrap";
import "containers/common/List.css";
import ReactTable from "react-table";
import { API } from "aws-amplify";

import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Creatable from 'react-select/creatable';

export default class SLMOwnerIsCompanyMappingList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "ownerIsCompanyMapping",
            dataRecord: "ownerIsCompanyMapping",
            dataSetPrimaryKey: "owner_is_company_keyword_result_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
        this.setState({ isLoading: true });     
        if (!this.props.isAuthenticated) { // if false
            return;
        }                        

        this.setState({ isLoading: false });      
    }

    



    componentWillUnmount() {
        this.setState({ addresses: [] });
    }



    async handleDataSave(data) {
        try {
            return API.post("colin", `/slmowneriscompanymapping/new`, {
                body: data
            });



        } catch (e) {
            alert("Error saving");
        }
    }

   

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete address");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
  
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
        this.handleSave(cellInfo, event);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

   


    

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            
                if (data[i].hasOwnProperty("modified") && (data[i].vendoriscompany || data[i].purchaseriscompany)) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave({input_value: data[i].vendor && data[i].vendoriscompany? data[i].vendor: data[i].purchaser
                                                                    , matched_on: "Manual Mapping"
                                                                    , created_by: this.props.user
                                                                    , last_edited_by: this.props.user});
                            if (result.result) {
                                data[i].modified = false;
                                alert(data[i].vendor && data[i].vendoriscompany? data[i].vendor: data[i].purchaser+" has been flagged as a company in the database.");
                                                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        if (data[cellInfo.index].hasOwnProperty("main_address")) {
            data.sort(function (a, b) { return b.main_address - a.main_address });
        }
        this.props.updateTableState(data, this.state.dataSet);

    }

    

    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({
            
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }

    
    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        if ((cellInfo.column.id=="vendoriscompany" && !this.props.data[cellInfo.index].vendor))
        {
            return null;
        }
        if ((cellInfo.column.id=="purchaseriscompany" && !this.props.data[cellInfo.index].purchaser))
        {
            return null;
        }

        switch (typeof (cellValue)) {
            case "boolean":
                
                
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

            case "number":
                return (
                    <input
                        onChange={this.handleNumberChange.bind(null, cellInfo)}
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        type="number"
                        className="no-border form-control"
                        value={cellValue!=null? cellValue: " "}

                    />
                );

            default:
                if (cellInfo.column.id.indexOf("date") >= 0) {
                    return (
                        <DatePicker
                            selected={cellValue!=null?  new Date(cellValue):""}
                            onChange={this.handleDateChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            dateFormat="dd/MM/yyyy"
                            className="no-border form-control"
                        />);
                }
                else {
                    return (
                        <input
                            onChange={this.handleInputChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            type="text"
                            className="no-border form-control"
                            value={cellValue!=null? cellValue:""}

                        />
                    );
                }

        }
    }

    


    renderTable(data) {
        const columns = [

            {
                id: 'saleid',
                Header: 'Sale ID',
                maxWidth: 60,
                accessor: 'saleid'
            },
             
            {
                id: 'vendor',
                Header: 'Vendor',
                accessor: 'vendor',
                maxWidth: 300


            },
            {
                id: 'vendoriscompany',
                Header: 'Vendor Is Company',
                accessor: 'vendoriscompany',
                maxWidth: 85,
                Cell: this.renderEditable

            },
            {
                id: 'purchaser',
                Header: 'Purchaser',
                accessor: 'purchaser',
                maxWidth: 300

            },
            {
                id: 'purchaseriscompany',
                Header: 'Purchase Is Company',
                accessor: 'purchaseriscompany',
                maxWidth: 85,
                Cell: this.renderEditable

            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={20}
                    sortable={false}
                />
            )
        }

    }

   

 

    renderComponent() {
        return (
            <div className="SLMOwnerIsCompanyMapping">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {/* {this.props.controlType === "table" && <Row className="show-Container">
                    <Col className="text-right" >
                        
                        <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>

                    </Col>
                </Row>} */}

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        { !this.state.isLoading  ? this.renderTable(this.props.data) : " " }
                        </Col>
                    </Row>
               

            </div>
        );
    }
    render() {
        if (!this.props.data) {
            return null
        }
        else {
            return (

                <div className="SLMOwnerIsCompanyMappingSection">
                    {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
                </div>
            );
        }
  }
}
